import { Permission } from '@/@types/permission';
import { isReportPermission } from './isReportPermission';

export function getUserRoleAvailablePages(userPermissions: Permission[] = []) {
  return userPermissions
    .map((permission) => permission.name)
    .filter(
      (permission) =>
        !isReportPermission(permission) && permission.includes('_read')
    )
    .map((permission) => permission.replace('_read', ''));
}
